import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import SpotAwardModal from '../components/spot-award/modal';
import {awardSpotScholarship} from '../actions';

const mapStateToProps = ({student, loading, collegeDataForStudent}) => ({
  student,
  loading,
  collegeDataForStudent,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({awardSpotScholarship}, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SpotAwardModal);
